<template>
  <div>
    <div v-if="errored" class="errored">Une erreur s'est produite 😥</div>

    <div v-else-if="loaded" id="cv-professionnel" :class="'resume ' + person.lang">
      <div class="container banner">
        <img v-if="person.cover_picture" :src="person.cover_picture" class="cover" />
        <div class="filter"></div>
        <div class="content-left">
          <img v-if="person.picture" :src="person.picture" class="profile" />
        </div>
        <div class="content-right">
          <h1>{{ person.name.first }} {{ person.name.last }}</h1>
          <span
            >{{ person.position }}<span v-if="person.birth.year"> — {{ lang.born }} {{ person.birth.year }}</span></span
          >
        </div>
      </div>

      <div class="container">
        <div class="content-left">
          <section v-if="person.about" class="about">
            <h2>{{ lang.about }}</h2>
            <div class="description">{{ person.about }}</div>
          </section>

          <section class="contact">
            <h2>{{ lang.contact }}</h2>
            <ul>
              <li v-if="person.contact.street">
                <i class="fa fa-home"></i>
                {{ person.contact.street }}, {{ person.contact.city }}
              </li>
              <li>
                <i class="fa fa-envelope"></i>
                <a :href="contactLinks.email">{{ person.contact.email }}</a>
              </li>
              <li>
                <i class="fa fa-phone"></i>
                <a :href="'tel:' + person.contact.phone">{{ person.contact.phone }}</a>
              </li>
              <li v-if="person.contact.website">
                <i class="fa fa-globe"></i>
                <a :href="person.contact.website" target="_blank">{{ person.contact.website }}</a>
              </li>
              <li v-if="person.contact.github">
                <i class="fa fa-github"></i>
                <a :href="contactLinks.github" target="_blank">{{ person.contact.github }}</a>
              </li>
            </ul>
          </section>

          <section v-if="person.education.length" class="education">
            <h2>{{ lang.education }}</h2>
            <div v-for="education in person.education" class="item">
              <h3>
                {{ education.degree_role }}, {{ education.degree_structure }}<br />
                <span class="timeperiod">{{ education.timeperiod }}</span>
              </h3>
              <div v-if="education.description" class="description">{{ education.description }}</div>
            </div>
          </section>
        </div>

        <div class="content-right">
          <table>
            <thead>
              <td></td>
            </thead>
            <tbody>
              <section v-if="person.experience.length" class="experience">
                <h2>{{ lang.experience }}</h2>
                <div v-for="experience in person.experience" class="item">
                  <h3>
                    {{ experience.position }}, {{ experience.company }}<br />
                    <span class="timeperiod">{{ experience.timeperiod_from }} - {{ experience.timeperiod_to || lang.today
                    }}</span>
                  </h3>
                  <div v-if="experience.description" class="description">{{ experience.description }}</div>
                </div>
              </section>

              <section v-if="person.projects.length" class="projects">
                <h2>{{ lang.projects }}</h2>
                <div v-for="project in person.projects" class="item">
                  <h3>
                    {{ project.name }}<br />
                    <span class="timeperiod">{{ project.timeperiod_from }} - {{ project.timeperiod_to }}</span>
                    <div class="meta">{{ project.platform }}<br />{{ project.url }}</div>
                  </h3>
                  <div v-if="project.description" class="description">{{ project.description }}</div>
                </div>
              </section>

              <section class="skills">
                <h2>{{ lang.skills }}</h2>
                <ul>
                  <li v-for="skill in person.skills">
                    <span>{{ skill.name }}</span>
                    <span class="skill-bar">
                      <span :style="'width: ' + skill.level + '%'" class="level"></span>
                    </span>
                  </li>
                </ul>
              </section>
            </tbody>
            <tfoot>
              <td></td>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="blue-background"></div>
    </div>

    <div v-else class="loading">Chargement en cours ⏰</div>
  </div>
</template>

<script>
import Vue from 'vue';
import { getVueOptions } from './options';

const name = 'cv-professionnel';
export default Vue.component(name, getVueOptions(name));
</script>

<style lang="less" scoped>
@page cv-professionnel {
  margin: 0;
}

.blue-background {
  display: none;
}

@media print {

  section,
  .item {
    break-inside: avoid;
  }

  .experience {
    margin-top: -18mm;
  }

  thead td,
  tfoot td {
    height: 18mm !important;
    background-color: @secondary-color;
  }

  @page :first {
    margin-top: 0 !important;

    thead,
    thead td {
      height: 0;
      display: none !important;
    }
  }

  .blue-background {
    background-color: @secondary-color;
    height: 100%;
    width: 122mm;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    display: block;
    z-index: -1;
  }
}

@primary-color: #374151;
@secondary-color: #eff6ff;
@third-color: #1d4ed8;
@normal: 11pt;
@big: 32pt;
@small: 10pt;

#cv-professionnel {
  position: relative;
  color: @primary-color;
  font-family: 'Brown', sans-serif;
  font-weight: 300;
  font-size: @normal;
  line-height: 17pt;
  page: cv-professionnel;
  .ar& {
    direction: rtl;
    font-family: 'Noto Sans Arabic', 'Brown', sans-serif;
    font-weight: 400;
  }

  .container {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    height: calc(100vh - 330px);
    height: 100%;

    .content-left {
      grid-column-start: 1;
      grid-column-end: 6;
      padding: 0 45px;
    }

    .content-right {
      grid-column-start: 6;
      grid-column-end: 13;
      background-color: @secondary-color;
      padding: 0 45px;
    }
  }

  .banner {
    position: relative;
    align-items: center;
    height: 330px;

    .cover {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .filter {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(10px);
    }

    .profile {
      border-radius: 100%;
      width: 240px;
      height: 240px;
      vertical-align: middle;
      backdrop-filter: blur(0);
    }

    .content-right {
      background-color: transparent;
      color: @third-color;
      height: initial;
      align-items: center;
      backdrop-filter: blur(0);
      font-weight: 800;

      h1 {
        font-size: @big;
        line-height: 1;
        margin: 0;
        .ar& {
          font-weight: 700;
        }
      }
    }
  }

  section {
    padding: 2cm 0 0;
    page-break-inside: avoid;
    break-inside: avoid;

    &:last-child {
      padding-bottom: 2cm;
    }
  }

  .item:not(:last-child) {
    margin-bottom: 0.3cm;
  }

  h2 {
    font-size: @normal;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 1cm;
    position: relative;
    width: fit-content;
    letter-spacing: 3px;
    .ar& {
      letter-spacing: 0;
      font-weight: 700;
    }

    &:after {
      width: 50%;
      height: 2px;
      background-color: @third-color;
      content: '';
      position: absolute;
      inset-inline-start: 0;
      bottom: -0.5cm;
    }
  }

  .description {
    white-space: pre-line;
  }

  h3 {
    font-size: @normal;
    margin: 0;
    .ar& {
      font-weight: 700;
    }
  }

  .timeperiod {
    text-transform: capitalize;
  }

  .meta {
    color: #6b7280;
    font-size: @small;
    margin-top: 0.15cm;
  }

  .contact ul {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      color: @primary-color;
      text-decoration: none;
    }
  }

  .skills ul {
    margin: 0;
    padding: 0;
    list-style: none;
    line-height: 1.6;

    li {
      display: grid;
      grid-template-columns: max-content 1fr;
      align-items: center;
      column-gap: 1cm;
    }

    .skill-bar {
      display: flex;
      background-color: #d1d5db;
      height: 5px;
      border-radius: 3px;
      overflow: hidden;
    }

    .level {
      background-color: @primary-color;
      height: 100%;
    }
  }
}
</style>
